import React from "react";
import {
    TextField,
    SelectField,
    ArrayField,
    Datagrid
} from 'react-admin';

class PhoneArrayField extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    render() {
        return (
            <ArrayField {...this.props}>
                <Datagrid>
                    <SelectField label="Тип контактного телефону" source="phoneType" choices={[
                        { id: 'MOBILE', name: 'мобільний' },
                        { id: 'LAND_LINE', name: 'стаціонарний' }
                    ]} />
                    <TextField label="Номер контактного телефона" source="phoneNumber" />
                </Datagrid>
            </ArrayField>
        );
    }
}

export default PhoneArrayField;
